import { User } from "./user";
import { UserStore } from "../stores/UserStore";

class NavigationItem {
  public title: string;
  public auth: boolean;
  public nav: boolean;
  public route: string | string[];
  public name: string;
  public icon: string;
  public canUserOpen: ((userstore: UserStore) => boolean) | undefined;

  constructor(
    title = "",
    auth = false,
    nav = false,
    route: string | string[] = "",
    icon = "",
    canUserOpen?: (userStore: UserStore) => boolean
  ) {
    this.title = title;
    this.auth = auth;
    this.nav = nav;
    this.name = this.title.toLowerCase().replace(/ /g, "-");
    this.route = route || this.name;
    this.icon = icon;
    this.canUserOpen = canUserOpen;
  }

  get href() {
    return `#/${this.route}`;
  }
}

export const navigation = [
  new NavigationItem("Dashboard", true, false, ["", "dashboard"]),
  new NavigationItem("Privacy", false, false, "privacy-policy"),
  new NavigationItem("Login", false, false, "login"),
  new NavigationItem("Email Login", false, false, "email-login"),
  new NavigationItem("Verify Account", false, false, "verify-account"),
  new NavigationItem("Password Reset", false, false, "password-reset"),
  new NavigationItem(
    "Landing Page",
    false,
    false,
    "landing-page/:organization"
  ),
  new NavigationItem("Video Player", true, false, "video/:id"),
  new NavigationItem("Watchlist", true, true, "watchlist", "access_time"),
  new NavigationItem("Reports", true, false, "reports/:level?"),
  new NavigationItem("Resources", true, true, "resources", "attachment"),
  new NavigationItem("Workshops", true, false, "workshops/:id"),
  new NavigationItem("Videos", true, false, "videos/:category?"),
  new NavigationItem(
    "My District",
    true,
    true,
    "mydistrict",
    "history_edu",
    userStore =>  userStore?.canViewDistrictContent
  ),
  new NavigationItem(
    "My School",
    true,
    true,
    "myschool",
    "history_edu",
    userStore =>  userStore?.canViewSchoolContent
  ),
  new NavigationItem("Live Events", true, true, "livestream", "3p"),
  new NavigationItem("Contact", false, true, "contact", "phone"),
  new NavigationItem("Profile", true, false, "profile", "person"),
  new NavigationItem("Settings", true, false, "settings"),
  new NavigationItem("History", true, false, "history"),
  new NavigationItem(
    "Search Results",
    true,
    false,
    "search-results/:query/:category?"
  )
];
